var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control border-radius-4px",on:{"change":_vm.update}},[_c('option',{attrs:{"value":"after"},domProps:{"selected":_vm.after}},[_vm._v(_vm._s(_vm.$t('client.after')))]),_vm._v(" "),_c('option',{attrs:{"value":"before"},domProps:{"selected":_vm.before}},[_vm._v(_vm._s(_vm.$t('client.before')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153e2c2a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/client/SelectPosition.vue
// module id = 1965
// module chunks = 0